export const arr2dict = <T>(arr: Array<T>, getKey: (item: T) => string): { [key: string]: T } => {
    return (arr ?? []).reduce((acc, item) => {
        const key = getKey(item);
        acc[key] = item;
        return acc;
    }, {} as { [key: string]: T });
}

type GroupByOptions = {
    keyPropertyName: string,
    itemsPropertyName: string,
}


export const groupBy = <T>(arr: Array<T>, getKey: (item: T) => string, customOptions: Partial<GroupByOptions> = {}) => {
    const options = {
        keyPropertyName: 'id',
        itemsPropertyName: 'items',
        ...customOptions,
    }

    const dict = {} as any;
    arr.forEach(item => {
        const key = getKey(item);
        dict[key] = dict[key] || {
            [options.keyPropertyName]: key,
            [options.itemsPropertyName]: [],
        };
        dict[key][options.itemsPropertyName].push(item);
    });

    return Object.values(dict);
}